import React, { useEffect, useMemo, useState } from 'react';
import { Stepper } from '@progress/kendo-react-layout';

const StepperComponent = ({currStep, processStatus}) => {
  const [currentStep, setCurrentStep] = useState(-1); // No step selected initially

  const processStatusString = useMemo(()=>processStatus?.length> 0 ? JSON.stringify(processStatus) : "",[processStatus])
  

  // const steps = [
  //   { label: 'Submitted' },
  //   { label: 'Approved' },
  //   { label: 'Submitted to Provider' },
  //   { label: 'Posted by Provider'},
  //   { label: 'Payroll Integeration Required' }
  // ];

  const steps = useMemo(() => [
    ...(processStatus?.map((item) => ({
      label: item?.StatusName
    })) || [])
], [processStatusString]);

//   const handleChange = (e) => {
//     setCurrentStep(e.value);
//   };

    const getNextObjectAndCurrentSeqById = (data, currentId) => {
    const currentIndex = data.findIndex(item => item.ID === currentId);
    if (currentIndex !== -1) {
      // const currentSeq = [1,2].includes(data[currentIndex].Seq) ? 0: data[currentIndex].Seq - 1;
      const currentSeq = data[currentIndex].Seq - 1;
      // const nextObject = currentIndex < data.length - 1 ? data[currentIndex + 1] : null;
      return {
        currentSeq: currentSeq,
        // nextObject: nextObject
      };
    }
    return null;
  }

     useEffect(()=>{
        const step = getNextObjectAndCurrentSeqById(processStatus,currStep)
        if(step){
            setCurrentStep(step.currentSeq)
        }
     },[processStatusString,currStep])

  return (
    <div>
        <style>
        {`

			.k-step-text {
    		white-space: normal !important;
    		overflow: visible !important;
    		text-overflow: initial !important;
  			}
            .k-stepper .k-step-label .k-step-text {
            max-width: calc(15em - 24px) !important;
            }
		`}
        </style>
      <Stepper 
      value={currentStep} 
    //   onChange={handleChange} 
      items={steps} />
    </div>
  );
};

export default StepperComponent;
